/**
 * Enum that holds the differnt values for the Twitch.Embed layout property.
 */
export var TwitchEmbedLayout;
(function (TwitchEmbedLayout) {
    /**
     * Default if channel is provided, and only supported for live content.
     * Shows both video and chat side-by-side.
     * At narrow sizes, chat renders under the video player.
     */
    TwitchEmbedLayout["VIDEO_WITH_CHAT"] = "video-with-chat";
    /**
     * Default if channel is not provided.
     * Shows only the video player (omits chat).
     */
    TwitchEmbedLayout["VIDEO"] = "video";
})(TwitchEmbedLayout || (TwitchEmbedLayout = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHdpdGNoRW1iZWRMYXlvdXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2V2ZXJ5dGhpbmcvVHdpdGNoRW1iZWRMYXlvdXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxpQkFZWDtBQVpELFdBQVksaUJBQWlCO0lBQzNCOzs7O09BSUc7SUFDSCx3REFBbUMsQ0FBQTtJQUNuQzs7O09BR0c7SUFDSCxvQ0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFaVyxpQkFBaUIsS0FBakIsaUJBQWlCLFFBWTVCIn0=